const tabs = document.querySelectorAll(".tabs__tab");
const contents = document.querySelectorAll(".category-content");
const scrollHelpers = document.querySelectorAll('.td-scroll-container');
const showMoreBtns = document.querySelectorAll('.show-more-btn');

window.addEventListener('DOMContentLoaded', function() {
  indicator(tabs[0])
  buttonActions()
});


function buttonActions () {
  showMoreBtns.forEach(btn =>{
    btn.addEventListener('click', () => {
      let index = btn.dataset.index
      btn.parentNode.parentNode.classList.add('content--expanded')
      scrollHelpers[index].classList.add('td-scroll-container__show')
    })
  })
}

tabs.forEach( tab => {
  tab.addEventListener('click',(e)=>{
    deactivateText(tab)
    indicator(tab)
  })
})

indicator(tabs[0])

contents.forEach((e, i) => {
  if (i > 0) {
    e.classList.add("content--hidden");
  }
});
  
function indicator(e){
  const tabsIndicator = document.querySelector('.category-tabs__indicator');
	tabsIndicator.style.left =  e.offsetLeft + "px";
  tabsIndicator.style.width = e.offsetWidth+"px";
}

function deactivateText(arg) {
  tabs.forEach((e, i) => {
    if (e.classList.contains("tab--active")) {
      e.classList.toggle("tab--active");
    }
    contents[i].classList.add("content--hidden");
  });
  activatetext(arg);
}

function activatetext(arg) {
  const contentData = arg.dataset.destination;
  arg.classList.toggle("tab--active");
  contents[contentData].classList.toggle("content--hidden");
}
